import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Award, Building2, Clock } from "lucide-react";
import { caseStudiesApi } from "../lib/api";

const CaseStudiesSection = ({ limit = 3 }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    caseStudiesApi.listPublic().then((d) => setItems((d || []).slice(0, limit))).catch(() => {});
  }, [limit]);

  if (!items || items.length === 0) return null;

  return (
    <section className="section-pad bg-white">
      <div className="lis-container">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="eyebrow">Success Stories</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">Real ISO journeys, real outcomes</h2>
            <div className="divider-red mt-4" />
          </div>
          <Link to="/case-studies" className="text-brand font-semibold text-sm inline-flex items-center gap-2">
            View all case studies <ArrowRight size={14} />
          </Link>
        </div>

        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => (
            <Link key={c.slug} to={`/case-studies/${c.slug}`} className="rounded-2xl overflow-hidden border border-slate-100 bg-white card-hover group flex flex-col">
              <div className="relative h-52 overflow-hidden">
                {c.image && <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                <span className="absolute top-3 left-3 chip"><Award size={12}/> {c.standard}</span>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500">
                  {c.industry && <span className="flex items-center gap-1"><Building2 size={12}/> {c.industry}</span>}
                  {c.duration && <span className="flex items-center gap-1"><Clock size={12}/> {c.duration}</span>}
                </div>
                <h3 className="mt-3 text-lg font-bold text-slate-900 leading-snug">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-600 flex-1 line-clamp-3">{c.outcome_summary}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand">
                  Read the story <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
